function envString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export const oauthEnv = {
  clientId: envString(import.meta.env.VITE_APP_OAUTH_CLIENT_ID),
  authority: envString(import.meta.env.VITE_APP_OAUTH_AUTHORITY),
  scope: envString(import.meta.env.VITE_API_OAUTH_SCOPE),
  domainHint: envString(import.meta.env.VITE_ENTRA_DOMAIN_HINT),
};
